<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import AddEdit from "./addedit.vue";
import dpagecategories from "@/models/dpagecategories";

export default {
  mixins: [apibtoast, apigeneric, dpagecategories],
  page: {
    title: "Talep",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
  },
  data() {
    return {
      title: this.$t("dpagecategories.Title"),
      items: [
        {
          text: this.$t("dpagecategories.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("dpagecategories.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("dpagecategories.Title"),
          active: true,
        },
      ],

      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },

      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      FilterTitle: "",
    };
  },
  methods: {
    Get() {
      this.ActionsFilterGet({
        Service: "DPageCategories",
        Page: this.Page,
        Filter: "&Title=" + this.FilterTitle,
      }).then((res) => {
        this.TableData = res.Data;

        this.Page.PageDataSize = this.TableData[0].totalcount;
      });
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-4">
                  <div class="search-box me-2 mb-2 d-inline-block">
                    <div class="position-relative">
                      <input
                        type="text"
                        @input="
                          FilterTitle.length >= 3 || FilterTitle.length == 0
                            ? Get()
                            : ''
                        "
                        v-model="FilterTitle"
                        class="form-control"
                        :placeholder="$t('dpagecategories.Page.Arama')"
                      />
                      <i class="bx bx-search-alt search-icon"></i>
                    </div>
                  </div>
                </div>
                <div class="col-sm-8">
                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-primary btn-rounded mb-2 me-2"
                      v-b-modal.dpagecategories
                      @click="
                        (DataUpdate = dpagecategoriesData), (AddEdit = 'Add')
                      "
                    >
                      <i class="mdi mdi-plus me-1"></i
                      >{{ $t("dpagecategories.Page.YeniKayitEkle") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("dpagecategories.Table.Baslik") }}</th>

                      <th style="width: 100px; text-align: center">
                        {{ $t("dpagecategories.Table.Islem") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <td>{{ Data.Title }}</td>

                      <td style="width: 100px; text-align: center">
                        <b-button-group>
                          <b-button
                            variant="success"
                            v-b-modal.dpagecategories
                            @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                            ><i class="far fa-edit"></i
                          ></b-button>
                          <b-button
                            variant="danger"
                            @click="Delete('DPageCategories', Data.Id)"
                            ><i class="far fa-trash-alt"></i
                          ></b-button>
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit :Id="DataUpdate" :AddEdit="AddEdit" @TableUpdate="Get" />
    </Layout>
  </Loader>
</template>
